export type NavLabelKey =
  | 'navigation.work'
  | 'navigation.services'
  | 'navigation.servicesDiscovery'
  | 'navigation.servicesDesign'
  | 'navigation.servicesDevelopment'
  | 'navigation.servicesDelivery'
  | 'navigation.expertise'
  | 'navigation.expertiseCharterIndustry'
  | 'navigation.expertiseDigitalTransformation'
  | 'navigation.about'
  | 'navigation.careers'
  | 'navigation.blog';

export interface NavLinkChild {
  href: string;
  labelKey: NavLabelKey;
}

export interface NavLinkWithChildren {
  href: string;
  labelKey: NavLabelKey;
  children: NavLinkChild[];
}

export type NavLink = NavLinkWithChildren | { href: string; labelKey: NavLabelKey; children?: never };

export function hasNavLinkChildren(link: NavLink): link is NavLinkWithChildren {
  return 'children' in link && Array.isArray(link.children) && link.children.length > 0;
}

export type NavServiceTheme = 'blue' | 'pink' | 'green' | 'orange';

export interface NavServiceCardConfig {
  descriptionKey: string;
  theme: NavServiceTheme;
  image: string;
}

export const navServicesCardConfig: Record<string, NavServiceCardConfig> = {
  '/services/discovery': {
    descriptionKey: 'navigation.servicesDiscoveryDescription',
    theme: 'blue',
    image: '/images/services/navigation/discovery.webp',
  },
  '/services/design': {
    descriptionKey: 'navigation.servicesDesignDescription',
    theme: 'pink',
    image: '/images/services/navigation/design.webp',
  },
  '/services/development': {
    descriptionKey: 'navigation.servicesDevelopmentDescription',
    theme: 'green',
    image: '/images/services/navigation/development.webp',
  },
  '/services/delivery': {
    descriptionKey: 'navigation.servicesDeliveryDescription',
    theme: 'orange',
    image: '/images/services/navigation/delivery.webp',
  },
};

export const navExpertiseCardConfig: Record<string, NavServiceCardConfig> = {
  '/charter-industry': {
    descriptionKey: 'navigation.expertiseCharterIndustryDescription',
    theme: 'blue',
    image: '/images/charter-industry/charter-industry.webp',
  },
  '/digital-transformation': {
    descriptionKey: 'navigation.expertiseDigitalTransformationDescription',
    theme: 'green',
    image: '/images/digital-transformation/digital-transformation.webp',
  },
};

export const navLinks: NavLink[] = [
  { href: '/work', labelKey: 'navigation.work' },
  {
    href: '/services',
    labelKey: 'navigation.services',
    children: [
      { href: '/services/discovery', labelKey: 'navigation.servicesDiscovery' },
      { href: '/services/design', labelKey: 'navigation.servicesDesign' },
      { href: '/services/development', labelKey: 'navigation.servicesDevelopment' },
      { href: '/services/delivery', labelKey: 'navigation.servicesDelivery' },
    ],
  },
  {
    href: '/expertise',
    labelKey: 'navigation.expertise',
    children: [
      { href: '/charter-industry', labelKey: 'navigation.expertiseCharterIndustry' },
      { href: '/digital-transformation', labelKey: 'navigation.expertiseDigitalTransformation' },
    ],
  },
  { href: '/about', labelKey: 'navigation.about' },
  { href: '/careers', labelKey: 'navigation.careers' },
  { href: '/blog', labelKey: 'navigation.blog' },
];
